/**
 * @fileoverview gRPC-Web generated client stub for org.codetricks.construction.code.assistant.service
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.21.12
// source: task.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as task_pb from './task_pb'; // proto import: "task.proto"


export class TaskServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetTaskStatus = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.TaskService/GetTaskStatus',
    grpcWeb.MethodType.UNARY,
    task_pb.GetTaskStatusRequest,
    task_pb.GetTaskStatusResponse,
    (request: task_pb.GetTaskStatusRequest) => {
      return request.serializeBinary();
    },
    task_pb.GetTaskStatusResponse.deserializeBinary
  );

  getTaskStatus(
    request: task_pb.GetTaskStatusRequest,
    metadata?: grpcWeb.Metadata | null): Promise<task_pb.GetTaskStatusResponse>;

  getTaskStatus(
    request: task_pb.GetTaskStatusRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: task_pb.GetTaskStatusResponse) => void): grpcWeb.ClientReadableStream<task_pb.GetTaskStatusResponse>;

  getTaskStatus(
    request: task_pb.GetTaskStatusRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: task_pb.GetTaskStatusResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.TaskService/GetTaskStatus',
        request,
        metadata || {},
        this.methodDescriptorGetTaskStatus,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.TaskService/GetTaskStatus',
    request,
    metadata || {},
    this.methodDescriptorGetTaskStatus);
  }

  methodDescriptorStartBillingHoldLifecycleProbe = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.TaskService/StartBillingHoldLifecycleProbe',
    grpcWeb.MethodType.UNARY,
    task_pb.StartBillingHoldLifecycleProbeRequest,
    task_pb.StartBillingHoldLifecycleProbeResponse,
    (request: task_pb.StartBillingHoldLifecycleProbeRequest) => {
      return request.serializeBinary();
    },
    task_pb.StartBillingHoldLifecycleProbeResponse.deserializeBinary
  );

  startBillingHoldLifecycleProbe(
    request: task_pb.StartBillingHoldLifecycleProbeRequest,
    metadata?: grpcWeb.Metadata | null): Promise<task_pb.StartBillingHoldLifecycleProbeResponse>;

  startBillingHoldLifecycleProbe(
    request: task_pb.StartBillingHoldLifecycleProbeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: task_pb.StartBillingHoldLifecycleProbeResponse) => void): grpcWeb.ClientReadableStream<task_pb.StartBillingHoldLifecycleProbeResponse>;

  startBillingHoldLifecycleProbe(
    request: task_pb.StartBillingHoldLifecycleProbeRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: task_pb.StartBillingHoldLifecycleProbeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.TaskService/StartBillingHoldLifecycleProbe',
        request,
        metadata || {},
        this.methodDescriptorStartBillingHoldLifecycleProbe,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.TaskService/StartBillingHoldLifecycleProbe',
    request,
    metadata || {},
    this.methodDescriptorStartBillingHoldLifecycleProbe);
  }

  methodDescriptorCancelBillingHoldLifecycleProbe = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.TaskService/CancelBillingHoldLifecycleProbe',
    grpcWeb.MethodType.UNARY,
    task_pb.CancelBillingHoldLifecycleProbeRequest,
    task_pb.CancelBillingHoldLifecycleProbeResponse,
    (request: task_pb.CancelBillingHoldLifecycleProbeRequest) => {
      return request.serializeBinary();
    },
    task_pb.CancelBillingHoldLifecycleProbeResponse.deserializeBinary
  );

  cancelBillingHoldLifecycleProbe(
    request: task_pb.CancelBillingHoldLifecycleProbeRequest,
    metadata?: grpcWeb.Metadata | null): Promise<task_pb.CancelBillingHoldLifecycleProbeResponse>;

  cancelBillingHoldLifecycleProbe(
    request: task_pb.CancelBillingHoldLifecycleProbeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: task_pb.CancelBillingHoldLifecycleProbeResponse) => void): grpcWeb.ClientReadableStream<task_pb.CancelBillingHoldLifecycleProbeResponse>;

  cancelBillingHoldLifecycleProbe(
    request: task_pb.CancelBillingHoldLifecycleProbeRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: task_pb.CancelBillingHoldLifecycleProbeResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.TaskService/CancelBillingHoldLifecycleProbe',
        request,
        metadata || {},
        this.methodDescriptorCancelBillingHoldLifecycleProbe,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.TaskService/CancelBillingHoldLifecycleProbe',
    request,
    metadata || {},
    this.methodDescriptorCancelBillingHoldLifecycleProbe);
  }

}

export class ArchitecturalPlanWriteAsyncServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorStartAsyncIngestFile = new grpcWeb.MethodDescriptor(
    '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteAsyncService/StartAsyncIngestFile',
    grpcWeb.MethodType.UNARY,
    task_pb.StartAsyncIngestFileRequest,
    task_pb.StartAsyncIngestFileResponse,
    (request: task_pb.StartAsyncIngestFileRequest) => {
      return request.serializeBinary();
    },
    task_pb.StartAsyncIngestFileResponse.deserializeBinary
  );

  startAsyncIngestFile(
    request: task_pb.StartAsyncIngestFileRequest,
    metadata?: grpcWeb.Metadata | null): Promise<task_pb.StartAsyncIngestFileResponse>;

  startAsyncIngestFile(
    request: task_pb.StartAsyncIngestFileRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: task_pb.StartAsyncIngestFileResponse) => void): grpcWeb.ClientReadableStream<task_pb.StartAsyncIngestFileResponse>;

  startAsyncIngestFile(
    request: task_pb.StartAsyncIngestFileRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: task_pb.StartAsyncIngestFileResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteAsyncService/StartAsyncIngestFile',
        request,
        metadata || {},
        this.methodDescriptorStartAsyncIngestFile,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/org.codetricks.construction.code.assistant.service.ArchitecturalPlanWriteAsyncService/StartAsyncIngestFile',
    request,
    metadata || {},
    this.methodDescriptorStartAsyncIngestFile);
  }

}

